/**
 * Datalayer for the Colour Selector Banner — Starlight EV TSD §1, Section 3.
 *
 * Fires page:linkClick only on an explicit swatch click — the default/active
 * swatch on page load must NOT fire (colorSelectorBanner.js syncs the initial
 * state directly, without a click, so no extra guard is needed here).
 *
 * There is no interest layer for this section — the colour name is the
 * action directly, so componentId/componentName = color-selector:<colour-slug>
 * (e.g. "Night Blue" → color-selector:night-blue).
 */

import { qsa } from '@utils/helpers';
import { pushLinkClick } from '@utils/page-datalayer';

const ROOT_SELECTOR = '[data-cmp="colorSelectorBanner"]';
const SWATCH_SELECTOR =
    '[data-cmp-hook-color-selector-banner="color-selector"] .cmp-color-selector-banner__swatch';
const LOCATION = 'color-selector';

function slugify(text) {
    return (text || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}

function buildId(...parts) {
    return parts.filter(Boolean).join(':');
}

function initOne(el) {
    if (el.dataset.dlColorSelectorInitialized === 'true') return;
    el.dataset.dlColorSelectorInitialized = 'true';

    qsa(SWATCH_SELECTOR, el).forEach((swatch) => {
        const colorName = (swatch.dataset.colorName || '').trim();
        const componentId = buildId(LOCATION, slugify(colorName));

        swatch.addEventListener('click', () => {
            pushLinkClick({
                interactionType: 'button_click',
                componentId,
                componentName: componentId,
                componentLabel: colorName,
                componentType: 'button'
            });
        });
    });
}

export function initAll(root = document) {
    qsa(ROOT_SELECTOR, root).forEach(initOne);
}

export default { selector: ROOT_SELECTOR, init: initAll };
